
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deposit-and-withdraw",
      function () {
        return require("private-next-pages/deposit-and-withdraw/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deposit-and-withdraw"])
      });
    }
  